import { useEffect } from 'react';
import { useHref } from 'react-router-dom';

import { OidcRedirectState } from '../hooks';
import { getLogoutRedirectState } from '../utils/getLogoutRedirectState';

export function LogoutRedirect() {
  const defaultPath = useHref('/');

  useEffect(() => {
    getLogoutRedirectState().then(state => {
      const path =
        (state !== null && (state.data as OidcRedirectState)?.refererPath) ||
        defaultPath;
      window.location.href = `${window.location.origin}${path}`;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
